module.exports = __webpack_public_path__ + "static/media/S3N2-2.58f0b504.svg";